import { render } from "./agencies.vue?vue&type=template&id=3d8e4a11"
import script from "./agencies.vue?vue&type=script&lang=js"
export * from "./agencies.vue?vue&type=script&lang=js"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__